"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _CustomJsonForms = _interopRequireDefault(require("../Product/CustomJsonForms"));

var _excluded = ["formJSON", "formUIJSON", "data", "onChange", "classes"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {}
  };
});

var DataForm = function DataForm(_ref) {
  var formJSON = _ref.formJSON,
      formUIJSON = _ref.formUIJSON,
      data = _ref.data,
      onChange = _ref.onChange,
      classes = _ref.classes,
      props = _objectWithoutProperties(_ref, _excluded);

  var c = useStyles({
    classes: classes
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: c.root
  }, /*#__PURE__*/_react["default"].createElement(_CustomJsonForms["default"], _extends({
    schema: formJSON,
    uischema: formUIJSON,
    data: data,
    onChange: onChange
  }, props)));
};

var _default = DataForm;
exports["default"] = _default;